const HTTP_STATUS = {
  OK: 200,
  REDIRECTION: 300,
};

export default async function fetchAPI({ method = 'GET', url, xsrfToken, payload = null }) {
  const res = await fetch(url, {
    method,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(xsrfToken
        ? {
            'x-mp-xsrf': xsrfToken,
          }
        : {}),
    },
    ...(payload
      ? {
          body: JSON.stringify(payload),
        }
      : {}),
  });

  if (res.status >= HTTP_STATUS.OK && res.status < HTTP_STATUS.REDIRECTION) {
    return res.json();
  }

  const error = new Error(res.statusText);
  error.response = res;
  throw error;
}
